import { Controller } from "@hotwired/stimulus"

// Minimal controller for activity card — toggle is handled by native <details>.
// Provides: close (cancel button), collapseAll (page-level), stopPropagation (checkbox).
export default class extends Controller {
  close() {
    this.element.removeAttribute("open")
  }

  collapseAll() {
    this.element.querySelectorAll("details[open]").forEach(d => d.removeAttribute("open"))
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  // The header checkbox belongs to its own mini form (form attribute), so a
  // toggle only sends shift[schedulable] and never rewrites the card.
  toggleSchedulable(event) {
    event.target.form.requestSubmit()
  }
}
